import { DomainModelCollection, ModelTypeDecorator } from '@nts/std';
import { MenuNodeAction } from './menu-node-action';
import { MenuNodeActionIdentity } from './menu-node-action.identity';

@ModelTypeDecorator(MenuNodeAction)
export class MenuNodeActionCollection extends DomainModelCollection<MenuNodeAction, MenuNodeActionIdentity> {

}
